export default "__VITE_ASSET__9c063df8__"